import React, {useState, useEffect} from 'react';
import Time from '../../Time';
import '../../css/App.css';
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap';
import PermissionsSettings from './PermissionsSettings';
import AdminNotificationSettings from './AdminNotificationsSettings';
import ScreenshotSettings from './ScreenshotsSettings';

class UsersSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        tab:"Permissions"
    }
   this.changeTab = this.changeTab.bind(this);

  }

  //Just put the correct time on the snoozer
  componentDidMount(){

  }

  changeTab = (tab) =>{

    //Changes the active button from active to inactive
    const collection = document.getElementsByClassName("nav-link active");
    collection[0].className = 'nav-link';

    //changes the button you clicked for active
    tab.target.className='nav-link active';
    this.setState({tab:tab.target.innerText})

  }

  render() {

    let SelectedSettings;
    if(this.state.tab == "Permissions"){
      SelectedSettings =  <PermissionsSettings/>
    }else if(this.state.tab == "Notifications"){
      SelectedSettings =  <AdminNotificationSettings/>
    }else if(this.state.tab == "Screenshots"){
      SelectedSettings =  <ScreenshotSettings/>
    }

    return(
      <div>
        <div className='pop-up comments-popup' onClick={this.props.close}></div>
        <div className="container pop-up-window settings-window py-3">
            <div className="row">
                <div className="col-12 container">
                  <h3>Settings</h3>
                </div>
            </div>
            <div className="row">
                <ul class="nav nav-tabs ">
                    <li class="nav-item">
                        <a className="nav-link active" onClick={this.changeTab} href="#">Permissions</a>
                    </li>
                    <li class="nav-item">
                        <a className="nav-link" onClick={this.changeTab} href="#">Notifications</a>
                    </li> 
                    <li class="nav-item">
                        <a className="nav-link" onClick={this.changeTab} href="#">Screenshots</a>
                    </li> 
                </ul>
                {SelectedSettings}
            </div>
        </div>
      </div>
    )
  }
}

export default UsersSettings;